module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/deer-9e004cd98a9b191f815a11b1b70f2301.svg";